import { useEffect } from 'react'
import { useTrackMutation } from '@mote/api'
import type { AccountTrackEventName } from '../../constants'
import { TRACK_EVENT_NAMES } from '../../constants'

export const useAccountPageTrack = (eventName: AccountTrackEventName) => {
  const trackMutation = useTrackMutation()

  useEffect(() => {
    //@ts-expect-error
    trackMutation.mutate({
      variables: {
        event: TRACK_EVENT_NAMES.site.account[eventName]
      }
    })
  }, [])
}
